var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "-2 0 9 9",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.65997 5.25L1.65997 5.04004C1.65997 3.88004 2.50996 3.31003 2.82996 3.09003C3.19996 2.84003 3.31995 2.67003 3.31995 2.41003C3.31995 1.91003 2.90997 1.5 2.40997 1.5C1.90997 1.5 1.5 1.91003 1.5 2.41003C1.5 2.82003 1.16 3.16003 0.75 3.16003C0.34 3.16003 0 2.82003 0 2.41003C0 1.08003 1.07997 0 2.40997 0C3.73997 0 4.81995 1.08003 4.81995 2.41003C4.81995 3.55003 3.97998 4.12002 3.66998 4.33002C3.27998 4.59002 3.15997 4.76004 3.15997 5.04004L3.15997 5.25C3.15997 5.67 2.81997 6 2.40997 6C1.99997 6 1.65997 5.66 1.65997 5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.75C0 0.34 0.34 0 0.75 0C1.16 0 1.5 0.34 1.5 0.75C1.5 1.16 1.17 1.5 0.75 1.5C0.33 1.5 0 1.16 0 0.75Z",
    transform: "translate(1.66 6.99)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question_mark.67459c3b606fbc06497fa15460a79993.svg";
export { ForwardRef as ReactComponent };